var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 447 364.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7a9a01;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.85,364.54H59.69c-32.92,0-59.69-26.78-59.69-59.69V59.69C0,26.78,26.78,0,59.69,0h245.15c32.92,0,59.69,26.78,59.69,59.69v245.15c0,32.91-26.78,59.69-59.69,59.69ZM59.69,31.77c-15.4,0-27.92,12.53-27.92,27.92v245.15c0,15.39,12.53,27.92,27.92,27.92h245.15c15.4,0,27.92-12.53,27.92-27.92V59.69c0-15.39-12.53-27.92-27.92-27.92H59.69Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.97,274.49c-6.88,0-13.76-2.63-19.01-7.88l-105.57-105.57c-10.5-10.5-10.5-27.52,0-38.02,10.5-10.5,27.52-10.5,38.02,0l105.57,105.57c10.5,10.5,10.5,27.52,0,38.02-5.25,5.25-12.13,7.88-19.01,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.97,274.49c-6.88,0-13.76-2.63-19.01-7.88-10.5-10.5-10.5-27.52,0-38.02L401.1,17.45c10.5-10.5,27.52-10.5,38.02,0,10.5,10.49,10.5,27.52,0,38.02l-211.14,211.14c-5.25,5.25-12.13,7.88-19.01,7.88Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.8fb68aa2901b524186f4a44f18cefa4b.svg";
export { ForwardRef as ReactComponent };